import React from 'react';
import loadingGif from '../../assets/images/loading.gif';

const LoadingPopup = ({ message = 'Loading...' }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(2px)',
        WebkitBackdropFilter: 'blur(2px)',
        zIndex: 99999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          padding: '28px 40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 15px 35px rgba(0, 0, 0, 0.25)',
          minWidth: '220px',
          textAlign: 'center',
        }}
      >
        <img
          src={loadingGif}
          alt="Loading..."
          style={{ width: '56px', height: '56px', marginBottom: '16px' }}
        />
        <h3
          style={{
            color: '#333333',
            margin: 0,
            fontSize: '18px',
            fontWeight: '600',
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          {message}
        </h3>
      </div>
    </div>
  );
};

export default LoadingPopup;
